module.exports = __webpack_public_path__ + "assets/product--background.b83af4b9.svg";